<template>
    <div class="main">

        <c-panel v-if="!carregado" :title="modoEdicao ? 'EDITAR MATRIZ CURRICULAR' : 'NOVA MATRIZ CURRICULAR'" titleIcon="fas fa-sitemap">
            <div class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <el-tabs v-else v-model="abaAtiva" type="border-card">

            <!-- ============================ ABA 1 — DADOS GERAIS ============================ -->
            <el-tab-pane label="DADOS GERAIS" name="gerais">
                <el-form label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="10">
                            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                                <el-input v-model="dados.nome" maxlength="191" show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                            <el-form-item label="Modalidade" prop="modalidade_id" :rules="[$requiredChange]">
                                <el-select v-model="dados.modalidade_id" filterable style="width: 100%;">
                                    <el-option v-for="m in init.modalidades" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                            <el-form-item label="Tipo de Ensino" prop="tipo_ensino" :rules="[$requiredChange]">
                                <el-select v-model="dados.tipo_ensino" style="width: 100%;">
                                    <el-option v-for="(l, v) in $CONSTANTS.TIPO_ENSINO" :key="v" :label="l" :value="parseInt(v)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4">
                            <el-form-item label="Nível Escolar" prop="nivel_escolar" :rules="[$requiredChange]">
                                <el-select v-model="dados.nivel_escolar" style="width: 100%;">
                                    <el-option v-for="(l, v) in $CONSTANTS.ETAPA" :key="v" :label="l" :value="parseInt(v)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Organização didático-pedagógica">
                                <el-select v-model="dados.organizacao_didatica" style="width: 100%;">
                                    <el-option v-for="o in init.enums.organizacaoDidatica" :key="o" :label="rotulo(o)" :value="o"></el-option>
                                </el-select>
                                <div style="color: #909399; font-size: 12px;">
                                    Define de onde vêm os componentes curriculares das etapas. Educação Infantil normalmente usa eixos temáticos.
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                            <el-form-item label="Organização das Etapas">
                                <el-select v-model="dados.forma_organizacao_etapas" style="width: 100%;">
                                    <el-option v-for="f in init.enums.formaOrganizacaoEtapas" :key="f" :label="rotulo(f)" :value="f"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="4">
                            <el-form-item label="Dias letivos">
                                <el-input-number v-model="dados.qtd_dias_letivos" :min="1" :step="1" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="4">
                            <el-form-item label="Qtd. períodos">
                                <el-input-number v-model="dados.qtd_periodos_avaliativos" :min="1" :step="1" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                            <el-form-item label="Tipo de período">
                                <el-select v-model="dados.tipo_periodo_avaliativo" style="width: 100%;">
                                    <el-option v-for="t in init.enums.tipoPeriodoAvaliativo" :key="t" :label="rotulo(t)" :value="t"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Período Letivo">
                                <el-select v-model="dados.periodo_letivo_id" filterable clearable placeholder="(nenhum)" style="width: 100%;">
                                    <el-option v-for="p in init.periodosLetivos" :key="p.id" :label="p.nome" :value="p.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4">
                            <el-form-item label="Situação">
                                <el-select v-model="dados.situacao" style="width: 100%;">
                                    <el-option :value="true" label="ATIVO"></el-option>
                                    <el-option :value="false" label="INATIVO"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row class="u-mt-15">
                        <el-col :xs="24" class="u-text-right">
                            <router-link to="/admin/matriz-curricular">
                                <el-button>VOLTAR</el-button>
                            </router-link>
                            <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- ============================ ABA 2 — ETAPAS ============================ -->
            <el-tab-pane name="etapas" :disabled="!matrizId">
                <span slot="label">ETAPAS <el-tag v-if="matrizId && qtdEtapas" size="mini" type="info">{{ qtdEtapas }}</el-tag></span>
                <etapas v-if="matrizId" :matriz-id="matrizId" :init="init" @total="qtdEtapas = $event"></etapas>
            </el-tab-pane>

            <!-- ============================ ABA 3 — PERÍODOS AVALIATIVOS (item 40) ============================ -->
            <el-tab-pane name="periodos" :disabled="!matrizId">
                <span slot="label">PERÍODOS AVALIATIVOS</span>
                <periodos v-if="matrizId" :matriz-id="matrizId" :init="init"></periodos>
            </el-tab-pane>

            <!-- ============================ ABA 4 — COMPONENTES ============================ -->
            <el-tab-pane name="componentes" :disabled="!matrizId">
                <span slot="label">COMPONENTES CURRICULARES</span>
                <componentes v-if="matrizId" :matriz-id="matrizId" :init="init" :organizacao-didatica="dados.organizacao_didatica"></componentes>
            </el-tab-pane>

        </el-tabs>

        <el-alert v-if="carregado && !matrizId" type="info" :closable="false" class="u-mt-10"
            title="Salve os dados gerais para liberar o cadastro das etapas e dos componentes curriculares."></el-alert>

    </div>
</template>

<script>
import Etapas from './etapas'
import Componentes from './componentes'
import Periodos from './periodos'

/** Rótulos dos enums que o backend devolve como string em initForm. */
const ROTULOS = {
    serie: 'Série', ciclo: 'Ciclo', modulo: 'Módulo', periodo: 'Período',
    bimestre: 'Bimestre', trimestre: 'Trimestre', semestre: 'Semestre', anual: 'Anual',
    disciplinas: 'Disciplinas', eixos_tematicos: 'Eixos Temáticos',
    base_nacional_comum: 'Base Nacional Comum', parte_diversificada: 'Parte Diversificada'
}

export default {
    components: { Etapas, Componentes, Periodos },
    data: () => ({
        abaAtiva: 'gerais',
        matrizId: null,
        qtdEtapas: 0,
        modoEdicao: false,
        carregado: false,
        organizacaoOriginal: null,
        dados: {
            nome: '',
            modalidade_id: null,
            tipo_ensino: null,
            nivel_escolar: null,
            organizacao_didatica: 'disciplinas',
            forma_organizacao_etapas: 'serie',
            qtd_dias_letivos: 200,
            qtd_periodos_avaliativos: 4,
            tipo_periodo_avaliativo: 'bimestre',
            periodo_letivo_id: null,
            situacao: true
        },
        init: { modalidades: [], cursos: [], disciplinas: [], eixosTematicos: [], periodosLetivos: [], enums: {} }
    }),
    mounted () {
        this.initForm()
    },
    methods: {
        rotulo (v) { return ROTULOS[v] || v },
        msgErro (r) {
            if (!r.data || !r.data.erro) return null
            return typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text
        },
        /**
         * O backend sinaliza "preciso de confirmação" terminando a mensagem com esta frase.
         * A tela não conhece a regra — apenas repete o texto e reenvia com o flag.
         */
        pedeConfirmacao (msg) {
            return !!msg && msg.indexOf('Confirme a operação para prosseguir.') !== -1
        },
        initForm () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/initForm`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.init = r.data || this.init
                if (this.$route.params.id) {
                    this.modoEdicao = true
                    this.carregar(this.$route.params.id)
                } else {
                    this.carregado = true
                }
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                Object.keys(this.dados).forEach(k => {
                    if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k]
                })
                this.dados.situacao = reg.situacao === false ? false : true
                this.matrizId = reg.id || null
                this.organizacaoOriginal = reg.organizacao_didatica
                this.qtdEtapas = Array.isArray(reg.etapas) ? reg.etapas.length : 0
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                this.enviar(false)
            })
        },
        enviar (confirmar) {
            window.eventBus.$emit('loading', true)

            const payload = JSON.parse(JSON.stringify(this.dados))
            if (confirmar) payload.confirmar_troca_organizacao = true

            const url = this.matrizId
                ? `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/update/${this.matrizId}`
                : `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/store`

            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)

                const erro = this.msgErro(r)
                if (erro) {
                    if (!confirmar && this.pedeConfirmacao(erro)) {
                        this.$msgbox.confirm(erro, 'Atenção', {
                            confirmButtonText: 'Confirmar', cancelButtonText: 'Cancelar', type: 'warning'
                        }).then(() => this.enviar(true)).catch(() => {})
                        return
                    }
                    window.eventBus.$emit('alert', { msg: erro, type: 'warning' })
                    return
                }

                window.eventBus.$emit('alert', {
                    msg: (r.data && r.data.mensagem) ? r.data.mensagem : 'Salvo com sucesso.',
                    type: 'success'
                })

                if (!this.matrizId) {
                    // Cadastro novo: o store devolve o registro criado; segue para as etapas.
                    this.matrizId = (r.data && r.data.id) ? r.data.id : null
                    this.modoEdicao = true
                    if (this.matrizId) {
                        this.$router.replace('/admin/matriz-curricular/edit/' + this.matrizId)
                        this.abaAtiva = 'etapas'
                    }
                }
                this.organizacaoOriginal = this.dados.organizacao_didatica
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
